import React, { useState } from 'react'
import {PALETTE} from '../../common/ThemeConstants'

import Card from 'react-bootstrap/Card'

import {Link} from 'react-router-dom'

export default function HomeImageCard({cover, text, to}) {
    const [isCardHover, setIsCardHover] = useState(false)

    const backgroundColor = isCardHover? PALETTE.WHITE : PALETTE.LIGHTGRAY
    return (
        <Link to={to} className="text-black text-center text-decoration-none">
            <Card
                onMouseEnter={() => setIsCardHover(true)}
                onMouseLeave={() => setIsCardHover(false)}
                className={"shadow text-center"}
                style={{ backgroundColor:backgroundColor, border:"0px solid" }}
            >
                <Card.Img src={cover} alt={text}/>
                <Card.ImgOverlay className="py-4">
                    <p style={{fontSize:22, color:PALETTE.DARKGRAY}}>{text}</p>
                </Card.ImgOverlay>
            </Card>
        </Link>
    )
}

